import Layout from '@layout/Index'

export const storeCollection = [
  {
    path: '/store-collection',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "StoreCollectionTable" */ './pages/StoreCollectionTable.vue'),
        name: '门店信息收集',
        meta: {
          title: '门店信息收集',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/store-collection/store-collection.route.js